import {Box, Card, CardHeader, Stack, Typography, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {SERVICE_CONFIG} from './ServiceConfig';

interface ServiceCardProps {
  service: string;
  amount: number;
  billedUnits: number;
  key: string;
}

export default function ServiceCard({service, amount, billedUnits}: ServiceCardProps) {
  const {t} = useTranslation();
  const theme = useTheme();

  // 1. Tomamos la config del servicio
  const serviceConfig = SERVICE_CONFIG[service] ?? {
    divisor: 1,
    label: 'billing.units',
  };

  // 2. Aplicamos la división correcta
  const billedUnitsToDisplay = billedUnits / serviceConfig.divisor;

  return (
    <Card sx={{display: 'inline-block', m: '0 24px', width: '200px'}}>
      <CardHeader
        title={t(`billing.${service}`.replaceAll('_', '-'))}
        sx={{width: '100%', backgroundColor: theme.palette.primary.main}}
        titleTypographyProps={{variant: 'h3'}}
      />
      <Box sx={{p: 2}}>
        <Stack direction={'row'} justifyContent="space-between">
          <Stack direction={'column'}>
            <Typography variant="h5" component="div" mb={0.5}>
              {t('billing.spent')}
            </Typography>
            <Typography
              variant="h5"
              component="div"
              fontSize={'1.3rem'}
              fontWeight={400}
              color="text.secondary"
            >
              ${Math.round(amount * 100) / 100}
            </Typography>
          </Stack>

          <Stack direction={'column'}>
            <Typography variant="h5" component="div" mb={0.5}>
              {t(serviceConfig.label)}
            </Typography>
            <Typography
              variant="h5"
              component="div"
              color="text.secondary"
              fontSize={'1.3rem'}
              fontWeight={400}
            >
              {serviceConfig.divisor === 1
                ? billedUnitsToDisplay
                : Math.round(billedUnitsToDisplay * 100) / 100}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Card>
  );
}
